﻿import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { ToasterService } from 'angular2-toaster';
import { Observable } from 'rxjs';
import { UsuarioService } from '../../service/usuario/usuario.service';
import { Identity } from '../_models/identity';
import { IdentityStorage } from '../_models/identity.storage';
import { TipoAutenticacao } from '../enums/tipo-autenticacao.enum';


import { AuthenticationResult } from '../_models/authentication-result';
import { UserPerfilResponse } from '../_models/user-perfil-response';
import { AutenticacaoTJBASeg } from './estrategiaLogin/autenticacao-tjbaseg';
import { Authenticator } from './estrategiaLogin/interface/authenticator';
import { AutenticacaoAdvogado } from './estrategiaLogin/autenticacao-advogado';
import { TrocarSenhaService } from 'src/app/service/trocar-senha/trocar-senha.service';




@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private estrategias: Map<TipoAutenticacao, Authenticator>;

    constructor(
        private http: HttpClient,
        private usuarioService: UsuarioService,
        public identityStorage: IdentityStorage,
        public local: LocalStorageService,
        private router: Router,
        private toasterService: ToasterService,
        private trocaSenhaService: TrocarSenhaService
    ) {
        this.estrategias = new Map<TipoAutenticacao, Authenticator>();
        this.estrategias.set(TipoAutenticacao.TJBASEG, new AutenticacaoTJBASeg(http, identityStorage, local));
        this.estrategias.set(TipoAutenticacao.EXTERNO, new AutenticacaoAdvogado(http, identityStorage, local));
    }

    authenticate(tipoAutenticacao: TipoAutenticacao, login: string, password: string): Observable<AuthenticationResult> {
        const autenticacao = this.estrategias.get(tipoAutenticacao);
        if (!autenticacao) {
            return Observable.of(new AuthenticationResult(false, "Método de autenticação não suportado."));
        }        
        return autenticacao.authenticate(login, password);
    }

    isExpired() {
        this.usuarioService.sessao().subscribe(_ => { }, _ => {
            this.toasterService.pop('error', 'A sessão expirou, por favor realize o login.');
            this.identityStorage.clearAuthData();
            this.router.navigate(['login-externo']);
            this.trocaSenhaService.fecharModal();
        });
    }


    getIdentity(): Identity {
        return this.identityStorage.getIdentity();
    }

    isAuthenticated(): boolean {
        return this.identityStorage.authenticationPresent();
    }

    clearAuthentication(): void {
        this.identityStorage.clearAuthData();
    }

    getPerfis(perfis: Array<UserPerfilResponse>) {
        let perfilArray = '';
        if (perfis != null) {
            perfis.forEach(element => {
                perfilArray += element.nome + ',';
            });
        }
        return perfilArray;
    }

    isAdminSistema(): boolean {
        let retorno = false;
        this.getIdentity().perfil.split(',').forEach(element => {
            if (element === 'ADMINISTRADOR') {
                retorno = true;
            }
        });
        return retorno;
    }
}
